import { Component, OnInit, Input, SimpleChanges, OnChanges, AfterViewInit } from '@angular/core';
import * as d3 from 'd3';
import { AppHubUtilService } from '../../../shared/services/app-hub-util.service';

@Component({
    selector: 'app-scatter-plot',
    templateUrl: './scatter-plot.component.html',
    styleUrls: ['./scatter-plot.component.css']
})
export class ScatterPlotComponent implements AfterViewInit, OnChanges, OnInit {

  constructor(public util: AppHubUtilService) { }
  @Input() private data: Array<any>;
  idDiv: string;
  @Input() public configuration: {
    rowHeader: string;
    columnHeader: string;
    value: string;
    tcoValue: string;
    width: string;
    name: string;
    cellSize: string;
    yElements: Array<string>;
    xAxisLabel: string;
    margin: { top: number; bottom: number; left: number; right: number };
    cellClick:any;
    id: string;
    componentContext: any;

  };
  public color: any = '';
  
  ngOnInit() {

    this.idDiv = '#' + this.configuration.id;
  }

  // tslint:disable-next-line: use-lifecycle-interface
  ngAfterViewInit() {
    this.showGraph();
  }
  // tslint:disable-next-line: use-lifecycle-interface
  ngOnChanges(changes: SimpleChanges) {
    if (changes.data) {
      this.showGraph();
    }
  }
  showGraph() {
    // append the svg object to the body of the page

    d3.select(this.idDiv).select('svg').remove();
    const margin = { top: 20, right: 50, bottom: 130, left: 50 };
    const  width = 600 - margin.left - margin.right;
    const height = 360 - margin.top - margin.bottom;
    const svg = d3.select(this.idDiv)
      .append('svg')
      .attr('width', width + margin.left + margin.right)
      .attr('height', height + margin.top + margin.bottom)
      .append('g')
      .attr('transform',
        'translate(' + margin.left + ',' + margin.top + ')');

    // Labels of row and columns
    const yElements = this.configuration.yElements;
    const xElements = d3.set(this.data.map(item => item[this.configuration.rowHeader])).values();
    // Build X scales and axis:

    const x = d3.scaleBand()
      .range([0, width])
      .domain(xElements)
      .padding(0.1);
    svg.append('g')
      .attr('transform', 'translate(0,' + height + ')')
      .call(d3.axisBottom(x))
      .selectAll('text')
      .attr('font-weight', 'normal')
      .style('text-anchor', 'end')
      .attr('dx', '-.8em')
      .attr('dy', '.15em')
      .attr('transform', () => {
        return 'rotate(-65)';
      });


    // Build X scales and axis:
    const y = d3.scaleBand()
      .range([height, 0])
      .domain(yElements)
      .padding(0.01);
    svg.append('g')
      .call(d3.axisLeft(y));

    // function onMouseClick() {
    //      this.configuration.cellClick.bind(this.configuration.componentContext);
    //   }
    const cells = svg
      .selectAll('rect')
      .data(this.data)
      .enter()
      .append('g')
      .on('click', this.configuration.cellClick.bind(this.configuration.componentContext))
      .on('mouseover', function () {
        d3.select(this).transition()
          .duration('50')
          .attr('opacity', '.85')
          .attr('cursor', 'pointer');
        d3.select(this).select('text')
          .text((d) => {
            return d.infra;
          })
          .attr('font-size', '10');
      })
      .on('mouseout', function () {
        d3.select(this).transition()
          .duration('50')
          .attr('opacity', '1');
        d3.select(this).select('text')
          .text((d) => {
            return d.appCount;
          })
          .attr('font-size', '16');
      });

    cells
      .append('rect')

      .attr('x', (d) => x(d[this.configuration.rowHeader]))
      .attr('y', (d) => y(d[this.configuration.columnHeader]))
      .attr('class', 'boxrect')
      .attr('text-anchor', 'start')
      .attr('fill', d => {
        if (d.appCount >= 1 && d.appCount <= 10) {
          return 'green';
        } else if (d.appCount >= 11 && d.appCount <= 25) {
          return 'orange';

        } else {
          return 'red';
        }
      })
      .attr('width', x.bandwidth())
      .attr('height', y.bandwidth() - 20)
      .on('click' , function() {
        svg.selectAll('rect').style('fill', () => {
          d3.select(this).style('fill', this.style.fill );
        });
        return  d3.select(this).style('fill', 'grey');
      });
      
    cells
      .append('text')
      .attr('y', d => y(d[this.configuration.columnHeader]) + 10)
      .attr('x', d => x(d[this.configuration.rowHeader]) + (x.bandwidth() / 2) - 10)
      .attr('dy', '.5em')
      .text((d) => d[this.configuration.value])
      .attr('fill', 'white')
      .attr('font-size', '14');
  }

  public onMouseClick = function( compData, color2) {
    return this.configuration.cellClick.bind(compData, color2);
  };

}



